import { render } from "./EmojiMessage.vue?vue&type=template&id=33206771&scoped=true"
import script from "./EmojiMessage.vue?vue&type=script&lang=js"
export * from "./EmojiMessage.vue?vue&type=script&lang=js"

import "./EmojiMessage.vue?vue&type=style&index=0&id=33206771&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33206771"]])

export default __exports__